import { EngagementFeedWithUser } from '@epicuro-next/data/engagement/engagement-models';
import { createAction, props } from '@ngrx/store';

/** Get article action */
export const getArticle = createAction(
  '[News Feed] Get Article',
  props<{ id: string }>(),
);

/** Get article success action */
export const getArticleSuccess = createAction(
  '[News Feed] Get Article Success',
  props<{ article: EngagementFeedWithUser }>(),
);

/** Get article fail action */
export const getArticleFail = createAction('[News Feed] Get Article Fail');
